<template>
  <div>
    <div class="row mt-5">
      <div class="col-lg-12 col-sm-12">
        <p class="text-center" v-scrollanimation>
          <span>Sıkça Sorulan Sorular</span>
        </p>
      </div>
    </div>
    <div class="row mt-5">
      <transition name="left">
        <div class="col-lg-6 col-md-6" v-if="goster">
          <div
            class="card card-body mt-2"
            v-for="(item, i) in article.slice(0, itemLength)"
            :key="i"
            @click="sssId(item.id)"
            data-toggle="collapse"
            data-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
            role="button"
            :id="item.id"
          >
            <h5 class="card-title text-center">
              {{ item.id + "." + item.baslik }}
            </h5>

            <span
              class="card-text collapse"
              id="collapseExample"
              v-if="item.id === items"
              >{{ item.icerik }}</span
            >
          </div>
        </div>
      </transition>
      <transition name="right">
        <div class="col-lg-6 col-md-6" v-if="goster">
          <div
            class="card card-body mt-2"
            v-for="(item, i) in article.slice(itemLength, article.length)"
            :key="i"
            @click="sssId(item.id)"
            data-toggle="collapse"
            data-target="#collapseExample2"
            aria-expanded="false"
            aria-controls="collapseExample2"
            role="button"
            :id="item.id"
          >
            <h5 class="card-title text-center">
              {{ item.id + "." + item.baslik }}
            </h5>
            <span
              class="card-text collapse"
              id="collapseExample2"
              v-if="item.id === items"
              >{{ item.icerik }}</span
            >
          </div>
        </div>
      </transition>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <p class="text-center mt-4" style="background-color: white">
          Soru ve cevaplar için <b> www.diyanet.gov.tr</b> referans alınmıştır!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import sssJson from "../sss.json";
export default {
  data() {
    return {
      goster: false,
      article: sssJson,
      itemLen: 0,
      items: 0,
    };
  },
  computed: {
    itemLength() {
      return (this.itemLen = Math.round(this.article.length / 2));
    },
  },
  methods: {
    sssId(index) {
      return (this.items = index);
    },
  },
  mounted() {
    return (this.goster = true);
  },
};
</script>

<style scoped>
* {
  font-family: "Nunito Sans", sans-serif;
}
p {
  background-color: #333;
  width: 50%;
  margin: auto;
  border-radius: 10px;
}
p > span {
  font-size: 40px;
  color: white;
}
.card {
  border: 1px solid #333;
}
.before-enter {
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.5s ease-in;
}
.enter {
  opacity: 1;
  transform: scale(1);
}

.left-enter-active {
  animation: left-in 1s;
}
.left-leave-active {
  animation: left-in 1s reverse;
}

@keyframes left-in {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

.right-enter-active {
  animation: right-in 1s;
}
.right-leave-active {
  animation: right-in 1s reverse;
}
@keyframes right-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sacrificed.vue